import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { RefObject } from 'react';
import { LearnMoreWarning } from 'routes/smart-quote/components/learn-more-warning';

import './style.scss';
import { PromptHeader } from 'routes/smart-quote/components/prompt-configurator/prompt-header';
import { PromptInput } from 'routes/smart-quote/components/prompt-configurator/prompt-input';
import { PromptData, useSendPrompt } from 'routes/smart-quote/hooks/use-send-prompt';
import { useHasActiveTabSmartQuotePrompts } from 'routes/smart-quote/hooks/use-sort-prompts';
import { addClientCheckStepThunk } from 'state/workspaces/smart-quote/thunks';

type PromptConfiguratorProps = {
  pageRef: RefObject<HTMLDivElement | null>;
};

const PromptConfiguratorFooter = ({ pageRef }: PromptConfiguratorProps) => {
  const thunkDispatch = useThunkDispatch();
  const tabId = useAssertedActiveTabId();
  const { handlePromptSubmit } = useSendPrompt(pageRef);
  const hasPrompt = useHasActiveTabSmartQuotePrompts();
  const isInternalUser = useIsInternalUser();

  const handleOnSubmit = ({ email, client }: PromptData) => {
    if (isInternalUser && !client) {
      thunkDispatch(addClientCheckStepThunk(tabId, email, pageRef));
      return;
    }

    handlePromptSubmit({ email, client });
  };

  return (
    <div className="smart-quote-footer sticky-bottom bg-fadeout">
      <div className="flex-y">
        {!hasPrompt && <PromptHeader />}
        <PromptInput onSubmit={handleOnSubmit} pageRef={pageRef} />
        {hasPrompt && <LearnMoreWarning />}
      </div>
    </div>
  );
};

export default PromptConfiguratorFooter;
